import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { buttonBaseHeight } from '@/components/ui/Button/ButtonBase/ButtonBase';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
/**
 * 名刺登録 フォーム
 * @param props
 * @returns
 */
export const CardFormSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-col gap-y-32 w-full', className) }, { children: [_jsx("div", Object.assign({ className: 'flex flex-col gap-y-32' }, { children: _jsx("div", Object.assign({ className: 'w-full sm:w-[192px] lg:w-[240px] mx-auto' }, { children: _jsx(Skeleton, { className: clsx(buttonBaseHeight.md), roundedCorner: 'full' }) })) })), _jsx("div", Object.assign({ className: 'w-full sm:w-[160px] lg:w-[208px] mx-auto' }, { children: _jsx(Skeleton, { className: clsx(buttonBaseHeight.md), roundedCorner: 'full' }) }))] })));
};
